<template>
  <div class="top">
    <div class="upper-container" v-if="value || myCircles.length > 0">
      <div class="wrapper">
        <span class="title">Circles you’ve joined</span>
        <form class="nosubmit" onSubmit="return false;">
          <input class="nosubmit" type="search" v-model="value" placeholder="Search by condition" @input="callDebounce" @keyup.enter="callDebounce" />
          <font-awesome-icon v-if="value" class="xmark" size="lg" :style="{ transform: 'scale(1.0)' }" :icon="['fal', 'times']" @click="handleClearSearch" />
        </form>
      </div>
    </div>
    <div v-if="isFetchingCircles" class="d-flex align-items-center flex-column justify-content-center mt-4">
      <div>
        <div class="spinner-border spinner-class"></div>
      </div>
      <div>Loading circles...</div>
    </div>
    <div v-if="!isFetchingCircles && myCircles.length > 0" class="results-count">{{ pagination }} {{ pagination > 1 ? "Results" : "Result" }}</div>
    <div class="lower-container" v-if="!isFetchingCircles && myCircles.length > 0">
      <div class="AllCirclesCard" v-for="(circle, index) in myCircles" :key="index">
        <div class="cardContainer">
          <div class="leftContent">
            <div class="img-cont" v-if="circle.circle_attach && circle.circle_attach.resized_images && circle.circle_attach.resized_images.dov640x320">
              <img loading="lazy" class="CircleImage" :src="circle.circle_attach.resized_images.dov640x320" alt="circleImage" />
            </div>
            <div class="no-img" v-else>
              <img src="../../../assets/icons/no-image.svg" width="20px" height="18px" alt="defualtImage" />
            </div>
            <div class="info">
              <span class="CircleTitle" v-if="circle.condition_type">
                {{ circle.condition_type.slice(0, 30) }}
                {{ circle.condition_type.length > 30 ? "..." : "" }}
              </span>
              <span v-if="circle.description" class="CircleDesc">
                {{ circle.description.slice(0, 95) }}
                {{ circle.description.length > 95 ? "..." : "" }}
              </span>
              <div class="additional-info">
                <span class="status">Joined as</span>
                <span v-for="(item, index) in circle.user_roles" :key="index">
                  <div v-if="index === 2" class="patient-tag">+{{ circle.user_roles.length - index }}</div>
                  <div v-if="index < 2">
                    <span v-if="item.toLowerCase() === 'patient'" class="patient-tag">
                      <font-awesome-icon class="icon" :icon="['fal', 'user']" />
                      {{ item }}
                    </span>
                    <span v-if="item.toLowerCase() === 'caregiver'" class="patient-tag">
                      <img loading="lazy" class="icon" src="../../../assets/handsholdingheart.svg" alt="icon" />
                      {{ item }}
                    </span>
                    <span v-if="item.toLowerCase() === 'physician'" class="physcian-tag">
                      <img loading="lazy" class="icon" src="../../../assets/userdoctor-orange-tag.svg" alt="icon" />
                      {{ item }}
                    </span>
                    <span v-if="item.toLowerCase() === 'advocate'" class="advocate-tag">
                      <font-awesome-icon class="icon" :icon="['fal', 'bullhorn']" />
                      {{ item }}
                    </span>
                    <span v-if="item.toLowerCase() === 'hospital_administrator'" class="physcian-tag">
                      <img loading="lazy" class="icon" src="../../../assets/hospital-wide-orange-tag.svg" alt="icon" />
                      Hospital
                    </span>
                    <span v-if="item.toLowerCase() === 'doctor'" class="physcian-tag">
                      <img loading="lazy" class="icon" src="../../../assets/userdoctor-orange-tag.svg" alt="icon" />
                      Physician
                    </span>
                    <span v-if="item.toLowerCase() === 'nfp_administrator'" class="physcian-tag">
                      <font-awesome-icon class="icon" :icon="['fal', 'hand-holding-heart']" />
                      Non-For-Profit
                    </span>
                    <span v-if="item.toLowerCase() === 'clinic_administrator'" class="physcian-tag">
                      <img loading="lazy" class="icon" src="../../../assets/hospital-orange-tag.svg" alt="icon" />
                      Clinic
                    </span>
                    <span v-if="item.toLowerCase() === 'hcp'" class="physcian-tag">
                      <font-awesome-icon class="icon" :icon="['far', 'user-nurse']" />
                      Advanced Medical Professional
                    </span>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="rightContent">
            <a-button class="enter-bttn enterButton" @click="goToCircle(circle, $event)" :loading="activeCircleId === circle.id ? isPageRouting : false" id="enter">Enter</a-button>
          </div>
        </div>
      </div>
    </div>
    <p v-if="!isSearchGood && !isFetchingCircles" class="no-result">We couldn't find any conditions based on your input.</p>
    <div v-if="!isFetchingCircles && myCirclesInit.length === 0">
      <div class="container">
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">Sorry you haven't joined any Circles.</span>
            <span class="sub-dailog">Please join any circle to view your circles.</span>
            <button class="get-started-btn" @click="handlediscover">Discover new circles</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="myCircles.length > 0 && pagination > item" class="pagination-container">
      <a-pagination class="dovemed-custom-pagination" v-model="currentPage" :showSizeChanger="false" :total="pagination ? pagination : 0" show-less-items :pageSize="item" @change="handleChangePage" />
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import EmailVerifyModal from "../../Modals/EmailVerification"

const CircleRepository = RepositoryFactory.get("circle")
const UserRepository = RepositoryFactory.get("user")
const AppRepository = RepositoryFactory.get("app")

/**
 * Circle Management
 * @displayName Circles
 */
export default {
  name: "JoinedCircle",

  data() {
    return {
      item: 8,
      isPageRouting: false,
      activeCircleId: 0,
      myCircles: [],
      value: "",
      isFetchingCircles: false,
      currentPage: 1,
      isSearchGood: true,
      myCirclesInit: [],
    }
  },

  
  created() {
    console.warn("JoinedCircle.vue is created")
  },

  mounted() {
    this.init()
  },

  components: {
    EmailVerifyModal,
  },

  methods: {
    callDebounce: _.debounce(function () {
      this.handleGoToSelectedCircle(1)
    }, 500),

    async handleGoToSelectedCircle(page) {
      if (!this.currentPage) {
        this.currentPage = 1
      }
      if (page) {
        this.currentPage = page
      }
      // console.log(this.currentPage)
      // console.log(this.value)
      this.isFetchingCircles = true
      try {
        await CircleRepository.all(this.value, "", this.currentPage, this.item)
          .then(async res => {
            this.isSearchGood = res.data.data.my_circles ? (res.data.data.my_circles.length ? true : false) : false
            if (this.isSearchGood) {
              this.otherCircle = res.data.data.all_circles
              this.myCircles = res.data.data.my_circles
              this.pagination = res.data.paginator.my_circles_count
            } else {
              this.myCircles = []
              this.pagination = 0
            }
            this.isFetchingCircles = false
          })
          .catch(err => {
            this.isFetchingCircles = false
            // console.log(err)
          })
      } catch (e) {
        this.isFetchingCircles = false
      }
    },

    handleClearSearch() {
      this.value = ""
      this.handleGoToSelectedCircle(1)
    },

    /**
     * Initialization
     */
    async init(page) {
      if (page === undefined) {
        page = 1
      }
      this.isFetchingCircles = true
      try {
        await CircleRepository.all("", "", page, this.item)
          .then(async res => {
            if (res.data.data.hasOwnProperty("my_circles")) {
              this.myCircles = res.data.data.my_circles
              this.myCirclesInit = res.data.data.my_circles
              this.pagination = res.data.paginator.my_circles_count
            }
            this.isFetchingCircles = false
          })
          .catch(err => {
            // console.log(err)
            this.isFetchingCircles = false
          })
      } catch (e) {
        this.isFetchingCircles = false
      }
    },

    handleChangePage(page) {
      console.log(page, "pageination")
      this.currentPage = page
      document.body.scrollTop = 0
      if (this.value) {
        this.handleGoToSelectedCircle()
      } else {
        this.init(page)
      }
    },

    handlediscover() {
      this.$router.push({
        name: "CirclesAll",
      })
    },

    goToCircle(circleInfo, event) {
      this.selectedCircle = circleInfo.condition_type
      const target = event.target.id
      this.activeCircleId = circleInfo.id
      this.isPageRouting = true
      CircleRepository.all("", circleInfo.id)
        .then(res => {
          let circle = res.data.data.all_circles[0]
          if (!this.authUser) {
            document.body.scrollTop = 0
            setTimeout(() => {
              this.$refs.modal.open()
            }, 1000)
          } else if (this.authUser && this.authUser.user.hasOwnProperty("verified_account") && this.authUser.user.verified_account === false) {
            this.$refs.accVerify.showModal()
          } else {
            this.$store.dispatch("Circle/diseaseTypes", { type: circle.id })
            this.$store.commit("Circle/setCurrentCircle", { data: circle })
            target === "enter" ? this.checkAndRoute(circle) : this.goToCircleDescription(circle) //if there is more than one role to enable to there is more role do a if condition here with the new api
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    checkAndRoute(circle) {
      AppRepository.getHasMultiRole(this.currentCircle.id)
        .then(res => {
          if (!res.data.data.length) {
            let selectedRole

            selectedRole = this.$store.state.User.user.user.multiRole.filter(r => r.circle_id === this.currentCircle.id)[0].role

            const payload = {
              role: selectedRole,
              circle_id: this.currentCircle.id,
            }
            AppRepository.postHasMultiRole(payload).then(res => {
              UserRepository.getSelfProfile(this.authUser.user, circle.id).then(res => {
                this.$store.state.User.user.user.display_name = res.data.data.user_info.display_name ? res.data.data.user_info.display_name : "D"
                this.authUser.user.role = selectedRole
                this.$router.push(`/${this.currentCircle.key_name}/home/activity`)
              })
            })
          } else {
            this.$router.push(`/${this.currentCircle.key_name}/select-profile`)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
}
</script>

<style lang="scss">
.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2a71d4;
  border: none;
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #ffffff !important;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #ffffff !important;
}
</style>

<style scoped lang="scss">
.xmark {
  position: relative;
  left: 95%;
  top: -49px;
  cursor: pointer;

  @media only screen and (max-width: 710px) {
    left: 90%;
  }
}

.top {
  width: 100%;
}

.results-count {
  position: relative;
  top: 35px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  left: 10px;
}

.lower-container {
  margin-top: 70px;
}

.no-result {
  text-align: center;
  margin-top: 24px;
}

.get-started-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  background: #062b54;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
}

.sub-dailog {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #33415f;
}

.dailog {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  height: 115px;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  background: #f1f5f9;
  border-radius: 8px;
}

.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
}

.container {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  max-width: 792px;
  width: 100%;
  height: 229px;
}

.pagination-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  height: 36px;
}

.icon {
  width: 10.21px;
  height: 11.67px;
}

.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
}

.enterButton {
  background: #062b54;
  color: #ffffff;

  @media only screen and (max-width: 710px) {
    width: 100%;
  }
}

.img-cont {
  @media only screen and (max-width: 710px) {
    width: 100%;
    height: 243px;
  }
}

.no-img {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e2e8f0;
  width: 207px;
  height: 128px;

  @media only screen and (max-width: 900px) {
    width: 100%;
    height: 243px;
  }
}

.additional-info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 0px;
  gap: 8px;
  flex-wrap: wrap;
}

.status {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #647490;
}

.physcian-tag {
  text-transform: capitalize;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  gap: 4px;
  height: 22px;
  background: #fff0d6;
  border-radius: 4px;
  color: #f5a623;
  font-size: 12px;
  line-height: 14px;
  font-weight: 700;
}

.patient-tag {
  text-transform: capitalize;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  gap: 4px;
  height: 22px;
  background: #e1eaf7;
  border-radius: 4px;
  color: #2a71d4;
  font-size: 12px;
  line-height: 14px;
  font-weight: 700;
}

.advocate-tag {
  text-transform: capitalize;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  gap: 4px;
  height: 22px;
  background: #e1eaf7;
  border-radius: 4px;
  color: #2a71d4;
  font-size: 12px;
  line-height: 14px;
  font-weight: 700;
}

.CircleTitle {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
}

.CircleDesc {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  font-style: italic;
}

.info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
}

.CircleImage {
  object-fit: cover;
  width: 207px;
  height: 128px;

  @media only screen and (max-width: 710px) {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}

.rightContent {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 48px;
  height: 48px;
  @media only screen and (max-width: 710px) {
    justify-content: flex-start;
    width: 100%;
  }
}

.leftContent {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 48px 0px 0px;
  gap: 16px;
  max-width: 595px;
  width: 100%;
  @media only screen and (max-width: 710px) {
    display: flex;
    flex-direction: column;
    padding: 0px;
  }
}

.cardContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 100%;
  @media only screen and (max-width: 900px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
}

.AllCirclesCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 10px;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(60, 60, 60, 0.1);
  border-radius: 4px;
  margin-bottom: 16px;
}

.upper-container {
  width: 100%;
  padding: 24px;
  background: #ffffff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.wrapper {
  padding-top: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 744px;
  gap: 24px;
}

.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  text-align: center;
}

input[type="search"]::placeholder {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
}

form.nosubmit {
  border: none;
  padding: 0;
  width: 100%;
}

input.nosubmit {
  position: relative;
  top: -10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  background: #f8fafd;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 4px 4px 4px 48px;
  gap: 8px;
  font-size: 16px;
  line-height: 32px;
  width: 100%;
  font-weight: 700;
  height: 60px;
  background-image: url("../../../assets/images/search-icon.png");
  background-repeat: no-repeat;
  background-position: 18px;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/App/circle/JoinedCircle.vue